export default __webpack_public_path__ + "static/media/catlike160000.509140f1.png";